import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import api from 'common/api'

const fetchUpcomingVisits = createAsyncThunk('upcomingVisits/fetchUpcoming', async (userId: string) => {
  return api.get<APIVisit[]>(`/api/users/${userId}/visits/upcoming?limit=3`)
})

type APIVisit = {
  Id: string
  StartTime: string
  StartTimeZone: string
  HighSchoolId: string
  HighSchoolName: string
  Virtual?: boolean
}
type State = APIVisit[] | null
const initState: State = null

const slice = createSlice({
  name: 'upcomingVisits',
  initialState: initState as State,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchUpcomingVisits.fulfilled, (_, action) => {
      return action.payload
    })
  },
})

export const actions = {
  fetchUpcomingVisits,
  ...slice.actions,
}

export default slice.reducer
